import { capitalize } from 'lodash';

import { Icon } from '@/components/icon';
import { Tooltip } from '@/components/tooltip';
import { VisuallyHidden } from '@/components/visually-hidden';
import { DAYS_OF_WEEK } from '@/lib/constants';

interface Props {
  operatingDays: string[];
}

const DayOfWeekIndicator = ({ operatingDays }: Props) => {
  return (
    <ol className="grid w-full grid-cols-7">
      {DAYS_OF_WEEK.map((day) => {
        const isActive = operatingDays.includes(day);
        const userString = isActive ? `Departs ${capitalize(day)}` : `${capitalize(day)} - No service`;

        return (
          <li key={day} className="flex items-center justify-center">
            <Tooltip content={userString}>
              {isActive ? (
                <Icon aria-hidden="true" size="4" name="check" color="lightBlue.500" />
              ) : (
                <span aria-hidden="true" className="block h-2 w-2 rounded-full bg-grey-300" />
              )}
              <VisuallyHidden>{userString}</VisuallyHidden>
            </Tooltip>
          </li>
        );
      })}
    </ol>
  );
};

export { DayOfWeekIndicator };
